export enum ThemeName {
  LIGHT = '_light',
  DIMMED = '_dimmed',
  DARK = '_dark',
  BLACK = '_black',
}

export interface Theme {
  name: ThemeName,
}
